module.exports = __webpack_public_path__ + "static/media/tranquilandia.62b3db6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/tranquilandia.mp4
// module id = sPWS
// module chunks = 1